import { render, staticRenderFns } from "./singleCustomer.vue?vue&type=template&id=f1fa3cdc&scoped=true"
import script from "./singleCustomer.vue?vue&type=script&lang=js"
export * from "./singleCustomer.vue?vue&type=script&lang=js"
import style0 from "./singleCustomer.vue?vue&type=style&index=0&id=f1fa3cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fa3cdc",
  null
  
)

export default component.exports